import { P360FormModel } from '@/components/dynamic-form/model/dynamic-form';
import { P360FormCustomerModel } from '@/components/dynamic-form/model/dynamic-form-customer';
import { AiChatInformation } from '@/models/by-name/ai-chat-information';
import { CampaignResource } from '@/models/by-name/campaign-resource';
import { Company } from '@/models/company';
import { Gen0004 } from '@/models/general-information/gen-0004.collaborator';
import { Gen0040 } from '@/models/general-information/gen-0040.active-campaign';
import { NotificationCounterDTO } from '@/models/security/notification-counter-dto';
import { SecurityUser } from '@/models/security/security-user';
import { CampaignModel } from '@/pages/admin/campaign/model/admin.campaign';
import { Position } from '@capacitor/geolocation';
import { createAction, props } from '@ngrx/store';

// TODO: Remove this...
const appStoreGlobalLabels = {
  /* eslint-disable @typescript-eslint/naming-convention */
  SET_USER: 'SET_USER',
  SET_COLLABORATOR: 'SET_COLLABORATOR',
  SET_COMPANY: 'SET_COMPANY',

  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_IS_SAVING: 'SET_IS_SAVING',

  SET_SCREEN_ID: 'SET_SCREEN_ID',
  SET_TITLE: 'SET_TITLE',
  SET_SUBTITLE: 'SET_SUBTITLE',
  /* eslint-enable @typescript-eslint/naming-convention */
};

export const appStoreGlobalActions = {
  setUserAction: createAction(appStoreGlobalLabels.SET_USER, props<{ user: SecurityUser }>()),

  setCollaboratorAction: createAction(appStoreGlobalLabels.SET_COLLABORATOR, props<{ collaborator: Gen0004 }>()),

  setCompanyAction: createAction(appStoreGlobalLabels.SET_COMPANY, props<{ company: Company }>()),

  setIsLoadingAction: createAction(appStoreGlobalLabels.SET_IS_LOADING, props<{ isLoading: boolean }>()),

  setIsSavingAction: createAction(appStoreGlobalLabels.SET_IS_SAVING, props<{ isSaving: boolean }>()),

  setScreenIdAction: createAction(appStoreGlobalLabels.SET_SCREEN_ID, props<{ screenId: string }>()),

  setTitleAction: createAction(appStoreGlobalLabels.SET_TITLE, props<{ title: string }>()),

  setSubtitleAction: createAction(appStoreGlobalLabels.SET_SUBTITLE, props<{ subtitle: string }>()),

  setScreenSizeAction: createAction(
    'SET_SCREEN_SIZE',
    props<{
      isWeb: boolean;
      isSmall: boolean;
      isPortrait: boolean;
      isMedium: boolean;
      isLarge: boolean;
    }>(),
  ),

  setInnerHeightAction: createAction('SET_INNER_HEIGHT', props<{ innerHeight: number }>()),

  setInnerWidthAction: createAction('SET_INNER_WIDTH', props<{ innerWidth: number }>()),

  setConnectedAction: createAction('SET_CONNECTED', props<{ connected: boolean }>()),

  setAppointmentsToSyncAction: createAction('SET_APPOINTMENTS_TO_SYNC', props<{ appointmentsToSync: number }>()),

  setOrdersToSyncAction: createAction('SET_ORDERS_TO_SYNC', props<{ ordersToSync: number }>()),

  setCustomersToSyncAction: createAction('SET_CUSTOMERS_TO_SYNC', props<{ customersToSync: number }>()),

  setNotificationCounterAction: createAction(
    'GLOBAL_SET_NOTIFICATION_COUNTER',
    props<{ notificationCounter: number }>(),
  ),

  decreaseNotificationCounterAction: createAction('GLOBAL_DECREASE_NOTIFICATION_COUNTER', props<any>()),

  increaseNotificationCounterAction: createAction('GLOBAL_INCREASE_NOTIFICATION_COUNTER', props<any>()),

  setNotificationCounterDtoAction: createAction(
    'GLOBAL_SET_NOTIFICATION_COUNTER_DTO',
    props<{ notificationCounterDto: NotificationCounterDTO }>(),
  ),

  setNotificationCounterDtoTotalAction: createAction(
    'GLOBAL_SET_NOTIFICATION_COUNTER_DTO_TOTAL',
    props<{ value: number }>(),
  ),

  setNotificationCounterDtoStarredAction: createAction(
    'GLOBAL_SET_NOTIFICATION_COUNTER_DTO_STARRED',
    props<{ value: number }>(),
  ),

  setNotificationCounterDtoImportantAction: createAction(
    'GLOBAL_SET_NOTIFICATION_COUNTER_DTO_IMPORTANT',
    props<{ value: number }>(),
  ),

  setNotificationCounterDtoDeletedAction: createAction(
    'GLOBAL_SET_NOTIFICATION_COUNTER_DTO_DELETED',
    props<{ value: number }>(),
  ),

  setActiveCampaignsAction: createAction(
    'GLOBAL_SET_ACTIVE_CAMPAIGNS',
    props<{
      activeCampaigns: Gen0040[];
      campaignIds: number[];
      resourceIds: number[];
    }>(),
  ),

  setCampaignAction: createAction('GLOBAL_SET_CAMPAIGN', props<{ id: number; campaign: CampaignModel }>()),

  setCampaignResourcesAction: createAction(
    'GLOBAL_SET_CAMPAIGN_RESOURCES',
    props<{ id: number; resources: CampaignResource[] }>(),
  ),

  setCampaignsLoadingAction: createAction('GLOBAL_SET_CAMPAIGNS_LOADING', props<{ value: boolean }>()),

  setAiChatHistoryAction: createAction('GLOBAL_SET_AI_CHAT_HISTORY', props<{ aiChatHistory: AiChatInformation[] }>()),

  addAiChatHistoryAction: createAction('GLOBAL_ADD_AI_CHAT_HISTORY', props<AiChatInformation>()),

  delAiChatHistoryAction: createAction('GLOBAL_DELETE_AI_CHAT_HISTORY', props<{ errorId: any }>()),

  setDynamicFormsAssignedAction: createAction(
    'GLOBAL_SET_DYNAMIC_FORMS_ASSIGNED',
    props<{
      myFormsAssigned: P360FormCustomerModel[];
    }>(),
  ),

  setDynamicFormsAction: createAction(
    'GLOBAL_SET_DYNAMIC_FORMS',
    props<{
      myForms: P360FormModel[];
      isRefresh: boolean;
    }>(),
  ),

  enableDisableWatchUserPosition: createAction(
    '[GLOBAL]__ENABLE_DISABLE_WATCH_POSITION',
    props<{ isWatchingPosition: boolean }>(),
  ),
  setUserPosition: createAction('[GLOBAL]__SET_USER_POSITION', props<{ position: Position | null }>()),
};
